import get from 'lodash/get'
import {
  Datagrid,
  DateField,
  Filter,
  ReferenceField,
  TextField,
  TextInput,
  useRecordContext,
} from 'react-admin'

import { CustomDateField, StatusTextField } from '../Fields'
import CTList from '../List'

const SearchFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Search" source="search" alwaysOn />
  </Filter>
)

export const CustomReferenceDateField = ({ id, reference, label, source, condition, ...props }: any) => {
  const record = useRecordContext()
  const preload = get(record, 'console_metadata.preload', false)
  const cond = condition(preload)

  return (
    cond && (
      <ReferenceField source={id} reference={reference} label={label} link="show">
        <DateField
          source={source}
          options={{
            year: '2-digit',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            timeZoneName: 'short',
          }}
          {...props}
        />
      </ReferenceField>
    )
  )
}

const SearchList = (props: any) => (
  <CTList
    bulkActionButtons={false}
    filters={<SearchFilter />}
    sort={{ field: 'date_created', order: 'DESC' }}
    {...props}
  >
    <Datagrid optimized rowClick="show">
      <CustomDateField source="filter_options.origin_pickup_date__min" label="Pickup Date" />
      <TextField source="filter_options.origin_location" label="Origin" />
      <TextField source="filter_options.dest_location" label="Destination" />
      <TextField source="console_metadata.label" label="Label" />
      <StatusTextField source="status" />
      <TextField source="num_loads" label="Number of Loads" />
      <CustomReferenceDateField
        id="console_metadata.load_id"
        reference="loads"
        label="Previous Delivery"
        source="dest_delivery_date"
        condition={(preload: boolean) => !preload}
      />
      <CustomReferenceDateField
        id="console_metadata.load_id"
        reference="loads"
        label="Next Pickup"
        source="origin_pickup_date"
        condition={(preload: boolean) => preload}
      />
    </Datagrid>
  </CTList>
)

export default SearchList
